import CardFlip from './CardFlip';
import CardView from './CardView';

export default {
  Flip: CardFlip,
  View: CardView,
};
